import { render, staticRenderFns } from "./SupVideoPlayer.vue?vue&type=template&id=4d637448&scoped=true"
import script from "./SupVideoPlayer.vue?vue&type=script&lang=js"
export * from "./SupVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./SupVideoPlayer.vue?vue&type=style&index=0&id=4d637448&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d637448",
  null
  
)

export default component.exports